import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveUser: (state, { payload }) => {
      state.user = payload;
    },
    saveEmailIdentities: (state, { payload }) => {
      state.emailIdentities = payload;
    },
    clearUser: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const { saveEmailIdentities, saveUser, clearUser } = authSlice.actions;

export default authSlice.reducer;
